// time format
export const FORMAT_DATE_DISPLAY = "DD-MM-YYYY HH:mm:ss";
export const FORMAT_DATE = "DD/MM/YYYY";
